import React from 'react';
import PropTypes from 'prop-types';

const FOOTER_HEIGHT = 437;

class FooterToggle extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isFooterVisible: false,
    };

    this.toggleFooter = this.toggleFooter.bind(this);
    this.setFooterDisplayStyle = this.setFooterDisplayStyle.bind(this);
  }

  componentDidMount() {
    if (!this.props.enableBodyScroll) {
      document.body.style.overflow = 'hidden';
      window.scroll({ top: 0 });
    }
  }

  setFooterDisplayStyle(displayStyle) {
    const footer = document.getElementById(this.props.footerID);
    if (footer) {
      footer.style.display = displayStyle;
    }
  }

  toggleFooter() {
    const { isFooterVisible } = this.state;
    const footerStyle = isFooterVisible ? 'none' : 'block';
    this.setFooterDisplayStyle(footerStyle);
    window.scroll(0, isFooterVisible ? 0 : FOOTER_HEIGHT);
    this.setState(state => ({
      isFooterVisible: !state.isFooterVisible,
    }));
  }

  render() {
    const chevronType = this.state.isFooterVisible ? 'down' : 'up';
    return (
      <button onClick={this.toggleFooter} className="footer-toggle-button">
        <i className={`icon-chevron-${chevronType}`} />
      </button>
    );
  }
}

FooterToggle.defaultProps = {
  enableBodyScroll: false,
  footerID: 'footerContent',
};

FooterToggle.propTypes = {
  enableBodyScroll: PropTypes.bool,
  footerID: PropTypes.string,
};

export default FooterToggle;



// WEBPACK FOOTER //
// ./src-react/FooterToggle/index.jsx